<script setup>
  import Popup from "@/components/controls/Popup.vue";

  const emit = defineEmits(['subRegionClick']);

  const props = defineProps({
    region: {
      type: Object,
      required: true,
    }
  })
</script>
<template>
  <Popup
    v-if="region.subRegions"
    :id="props.region.name"
    class="jwx-regional-navigation__popup"
    icon="chevron-up-down"
    :iconSubtle="true"
    positionY="bottom"
    buttonSize="small"
    :hideDivider="false"
  >
    <template #default>
      <div class="jwx-action-menu">
        <ul class="jwx-action-menu__list">
          <li 
            v-for="subRegion in props.region.subRegions"
            :key="subRegion.name"
            class="jwx-action-menu__action"
          >
          <button
            @click.prevent="emit('subRegionClick', subRegion.c)"
            class="jwx-action-menu__action-button"
          >
            <div class="jwx-action-menu__action-label">{{ subRegion.name }}</div>
          </button>
          </li>
        </ul>
      </div>      
    </template>
  </Popup>          
</template>